<template>
  <div
    class="comments-toggle flex cursor-pointer items-center space-x-2 rounded-md p-1-5"
    :class="modelValue ? 'bg-primary/10' : 'hover:bg-gray-50'"
    data-cy="log-comments-toggle"
    @click="toggleCommentsSectionVisibility"
  >
    <icon-base
      :icon="IconComment"
      :fill="modelValue ? UTIL_COLORS.PRIMARY : undefined"
    />

    <div
      class="pill flex w-auto translate-y-0-25 transform items-center justify-center rounded-full px-1-5 text-center text-xs font-semibold"
      :class="
        modelValue ? 'bg-primary text-white' : 'bg-gray-200 text-gray-600'
      "
    >
      {{ count }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";

import IconComment from "@/components/icons/IconComment.vue";

const emit = defineEmits<{
  "update:modelValue": [boolean];
}>();

const props = defineProps({
  count: {
    type: Number,
  },
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const toggleCommentsSectionVisibility = () => {
  emit("update:modelValue", !props.modelValue);
};
</script>
